import React from "react";
import lowImpact from "assets/icons/lowImpact.svg";
import medImpact from "assets/icons/medImpact.svg";
import highImpact from "assets/icons/highImpact.svg";

interface ImpactCardProps {
  title: string;
  description: string;
  status: "High Impact" | "Medium Impact" | "Low Impact";
  score: number;
}

const statusColor: any = {
  "High Impact": "text-[#E55454]",
  "Medium Impact": "text-[#FE7526]",
  "Low Impact": "text-[#2E9C67]"
};

const getImpactScore = (score: number) => {
  if (!score) return {};
  if (score > 85) {
    return { headingBg: "bg-[#E1FFF0]", descBg: "bg-[#E1FFF066]", border: "border-[#6BD9B8]", statusColor: "text-[#2E9C67]", icon: lowImpact };
  } else if (score > 65) {
    return { headingBg: "bg-[#FFF1E9]", descBg: "bg-[#FFF1E966]", border: "border-[#FFBE82]", statusColor: "text-[#FE7526]", icon: medImpact };
  } else {
    return { headingBg: "bg-[#FFECEC]", descBg: "bg-[#FFECEC66]", border: "border-[#FF8B84]", statusColor: "text-[#E55454]", icon: highImpact };
  }
};

export const ImpactCard: React.FC<ImpactCardProps> = ({ title, description, status = "", score }) => {
  return (
    <div className={`relative mx-3 my-7 md:my-0 md:mx-0 flex flex-col items-center rounded-xl border-2 ${getImpactScore(score).descBg} ${getImpactScore(score).border}`}>
      <div className={`absolute -top-1 translate-y-[-50%] px-4 py-1 bg-white border border-[#E4E6F2] rounded-md shadow text-xs font-extrabold text-center z-10 ${statusColor[status]}`}>{status}</div>
      <div className={`${getImpactScore(score).headingBg} flex flex-row md:flex-col gap-4 md:gap-0 items-center w-full px-2 py-3 md:py-5 rounded-t-xl`}>
        <div className="w-8 h-8 md:w-20 md:h-20 border-[3px] border-none md:border-[#00000008] bg-transparent  md:bg-white rounded-full flex justify-center items-center">
          <img src={getImpactScore(score).icon} alt="Logo Img" className="w-auto md:w-12" />
        </div>
        <p className="text-base  md:text-xl font-extrabold">{title}</p>
      </div>
      <div className="w-full py-2 md:py-4 px-3 md:px-4 border-t">
        <p className="font-medium text-xs md:text-sm leading-[18px] md:leading-[22px] align-middle text-[#00000099]">{description}</p>
      </div>
    </div>
  );
};
